<template>
    <form class="pa-2">
      <v-layout row wrap style="max-width:900px">
        <v-flex xs6 px-2>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <v-flex xs6 px-2><h2>{{$t('Pilot.ChartConfig.ColorAxis')}}</h2></v-flex>
                <v-flex xs6 ><v-menu offset-y>
                  <v-btn small slot="activator" color="primary" dark :title="$t('Pilot.ChartConfig.SelectColorBarTooltip')">{{$t('Pilot.ChartConfig.PredefinedBar')}}<v-icon right dark >mdi-palette</v-icon></v-btn>
                  <v-list>
                    <v-list-tile v-for="colorDef in $options.colorList" :key="colorDef.name"  @click="updateColor(colorDef)">
                            <v-list-tile-title style="display:flex;"><div class="barre">{{colorDef.name}}</div><div class="ml-4 barre" :style="{backgroundImage: `linear-gradient(to right, ${colorDef.colorMin} , ${colorDef.colorMid}, ${colorDef.colorMax})`}"></div></v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu></v-flex>
              </v-layout>   
              <v-layout row wrap>                                          
                <v-flex xs6 px-2><v-text-field :label="$t('Pilot.ChartConfig.MaxValue')" v-model="maxColorValue"/></v-flex>          
                <v-flex xs6 px-2><color-picker :label="$t('Pilot.ChartConfig.MaxColor')" v-model="colorMax"/></v-flex>
                <v-flex xs6 px-2></v-flex>
                <v-flex xs6 px-2><color-picker :label="$t('Pilot.ChartConfig.MidColor')" v-model="colorMid"/></v-flex>              
                <v-flex xs6 px-2><v-text-field :label="$t('Pilot.ChartConfig.MinValue')" v-model="minColorValue" /></v-flex>
                <v-flex xs6 px-2><color-picker :label="$t('Pilot.ChartConfig.MinColor')" v-model="colorMin"/></v-flex>              
              </v-layout>  
            </v-card-title>
          </v-card>  
        </v-flex>
        <v-flex xs3 px-2>
          <v-card>
            <v-card-title>
              <h2>{{$t('Pilot.ChartConfig.XAxis')}}</h2>
              <v-text-field :label="$t('Pilot.ChartConfig.MinValue')" v-model="minXValue" />
              <v-text-field :label="$t('Pilot.ChartConfig.MaxValue')" v-model="maxXValue" />  
            </v-card-title>
          </v-card>                       
        </v-flex>          
        <v-flex xs3 px-2>
          <v-card>
            <v-card-title>
              <h2>{{$t('Pilot.ChartConfig.YAxis')}}</h2>
              <v-text-field :label="$t('Pilot.ChartConfig.MinValue')" v-model="minYValue" />
              <v-text-field :label="$t('Pilot.ChartConfig.MaxValue')" v-model="maxYValue" />
            </v-card-title>
          </v-card>    
        </v-flex>                    
        <v-flex xs12 style="display:flex"  justify-end>                
          <v-btn @click="resetChange" >{{$t('Pilot.ChartConfig.Default')}}<v-icon right>mdi-backup-restore</v-icon></v-btn>
          <v-btn @click="restoreChange" >{{$t('Pilot.ChartConfig.Restore')}}<v-icon right>mdi-replay</v-icon></v-btn>
          <v-btn @click="validChange" color="primary" >{{$t('Pilot.ChartConfig.Valid')}}<v-icon right>mdi-content-save</v-icon></v-btn>
        </v-flex>        
      </v-layout>                  
    </form>
</template>
<script>      
  import ColorPicker from '@/components/shared/ColorPicker'  
  import { GraphUiState } from '@/models/ui/GraphUiState';
  export default {
   name: 'ChartConfig',
   components:{ColorPicker},
    props:  {     
      uiid:{
          type: String,
          required: true
      },
      refresh:{
        type:Boolean,
        default:false
      }
   }, 
   data(){
      return {
        minXValue:"",
        minYValue:"",
        minColorValue:"",
        maxXValue:"",
        maxYValue:"",
        maxColorValue:"",
        colorMin:"",
        colorMid:"",
        colorMax:""
      }
    },  
   computed: {                
      graphUiState() {          
        //retourne un GraphUiState        
        return this.$store.myGetters.uistatebyuiid(this.uiid)
      }
    },
    mounted() {
      this.$options.defaultState = new GraphUiState()
      this.$options.colorList = [
        {name:"Alaska",colorMin:"#5A80AD",colorMid:"#FFFFFF",colorMax:"#BD0D24"},
        {name:"Hawaï",colorMin:"#5A80AD",colorMid:"#FDFD72",colorMax:"#BD0D24"},
        {name:"Norvegian",colorMin:"#5A80AD",colorMid:"#FFFFFF",colorMax:"#455238"},
        {name:"Sahara",colorMin:"#F6F6DC",colorMid:"#FFFF00",colorMax:"#BD0D24"},
        {name:"Angles",colorMin:"#5A80AD",colorMid:"#BD0D24",colorMax:"#5A80AD"}
      ]
      this.restoreChange()
    },   
    watch:{
      uiid(newValue) {
        this.restoreChange()
      },
      refresh(newValue) {
        if(newValue) this.restoreChange()
      }
    },  
    methods: {     
      validChange(){
        this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'colorMin',value:this.colorMin})
        this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'colorMid',value:this.colorMid})
        this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'colorMax',value:this.colorMax})                
        this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'custDomainX',value:this.minXValue === "" || this.maxXValue === ""?null:[parseFloat(this.minXValue),parseFloat(this.maxXValue)]})
        this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'custDomainY',value:this.minYValue === ""|| this.maxYValue === ""?null:[parseFloat(this.minYValue),parseFloat(this.maxYValue)]})
        this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'custDomainColor',value:this.minColorValue === "" || this.maxColorValue === ""?null:[parseFloat(this.minColorValue),(parseFloat(this.minColorValue)+parseFloat(this.maxColorValue)) / 2.0,parseFloat(this.maxColorValue)]})
        this.$store.myActions.UI_SET_MOVABLE_DIALOG_VISIBILITY(false)
      },
      restoreChange() {
        this.colorMin = this.graphUiState.colorMin
        this.colorMid = this.graphUiState.colorMid
        this.colorMax = this.graphUiState.colorMax     
        this.minXValue = this.graphUiState.custDomainX?this.graphUiState.custDomainX[0]:""
        this.maxXValue = this.graphUiState.custDomainX?this.graphUiState.custDomainX[1]:""
        this.minYValue = this.graphUiState.custDomainY?this.graphUiState.custDomainY[0]:""
        this.maxYValue = this.graphUiState.custDomainY?this.graphUiState.custDomainY[1]:""
        this.minColorValue = this.graphUiState.custDomainColor?this.graphUiState.custDomainColor[0]:""
        this.maxColorValue = this.graphUiState.custDomainColor?this.graphUiState.custDomainColor[2]:""   
      },
      resetChange() {        
        this.colorMin = this.$options.defaultState.colorMin
        this.colorMid = this.$options.defaultState.colorMid
        this.colorMax = this.$options.defaultState.colorMax
        this.minXValue = ""
        this.maxXValue = ""
        this.minYValue = ""
        this.maxYValue = ""
        this.minColorValue = ""                
        this.maxColorValue = ""
      },
      updateColor(colorDef) {
        this.colorMin = colorDef.colorMin
        this.colorMid = colorDef.colorMid
        this.colorMax = colorDef.colorMax        
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>  
.barre{
  display: inline-block;  
  flex: 1 0 auto;
  width: 1px;
}
</style>
